import Joi from 'joi';
import { ProductType } from 'constants.js';

const details = {
  name: Joi.string()
    .label('Survey Name')
    .min(3)
    .max(100)
    .required(),
  productName: Joi.string()
    .label('Product Type')
    .required(),
  subscriberListId: Joi.when('productType', {
    is: ProductType.List,
    then: Joi.string()
      .label('Subscribers List')
      .required()
  }),
  schemaIdentifier: Joi.string()
    .label('Event Type')
    .required(),
  surveyTheme: Joi.object({
    primaryColor: Joi.string()
      .label('Primary Color')
      .regex(/^#[A-Fa-f0-9]{6}/),
    secondaryColor: Joi.string()
      .label('Secondary Color')
      .regex(/^#[A-Fa-f0-9]{6}/),
    fontFamily: Joi.string().label('Font Family'),
    fontSize: Joi.number()
      .label('Font Size')
      .positive()
      .allow(null)
      .allow(''),
    fileSize: Joi.number()
      .max(1048576)
      .label('File Size'),
    fileFormat: Joi.string()
      .valid(...['image/png', 'image/jpeg', 'image/gif'])
      .label('File Format')
  })
};
const design = {
  details: Joi.string()
    .label('Survey Details')
    .required()
};

const actions = {
  surveyQuestionResponseRules: Joi.array()
    .items(
      Joi.object({
        surveyQuestionName: Joi.string()
          .required()
          .label('Survey Question'),
        matrixSubQuestionName: Joi.when('isMatrix', {
          is: true,
          then: Joi.string()
            .label('Survey Sub Question')
            .required()
        }),
        campaignUuid: Joi.string()
          .required()
          .label('Campaign'),
        conditionData: Joi.object({
          condition: Joi.string()
            .required()
            .label('Condition'),
            conditionValue: Joi.string()
            .required()
            .label('ConditionValue')
        }).required()
      })
    )
    .label('Survey Actions'),
  postProcessing: Joi.object({
    promoterScores: Joi.array().items(
      Joi.object({
        scoreName: Joi.string()
          .required()
          .label('Score Name'),
        questions: Joi.array().items(
          Joi.string()
              .required()
              .label('Question')
          )
      })
    )
  }).label('Post Processing')
};

const extraAddressesValidator = Joi.string().email({
  minDomainSegments: 2,
  tlds: { allow: false }
});

const sendResponseData = {
  fromName: Joi.string()
    .label('From Name')
    .min(3)
    .required(),
  fromAddress: Joi.string()
    .label('From Address')
    .email({ minDomainSegments: 2, tlds: { allow: false } })
    .required(),
  replyAddress: Joi.string()
    .label('Reply Address')
    .required()
    .email({ minDomainSegments: 2, tlds: { allow: false } }),
  ccAddresses: Joi.array().items(extraAddressesValidator),
  bccAddresses: Joi.array().items(extraAddressesValidator),
  surveyTemplateUuid: Joi.string().required()
};

export default {
  details,
  design,
  actions,
  sendResponseData,
  all: {
    ...design,
    ...details,
    ...actions
  }
};
